import { AddStorageAccountWizardComponent } from '@components/storage-accounts/add-storage-account-wizard/add-storage-account-wizard.component';
import { CreationMode } from '@components/storage-accounts/add-storage-account-wizard/add-storage-account-wizard.constants';
import { ITranslationService } from 'angular-i18next';
import { MbsSize, ModalService } from 'mbs-ui-kit';
import { StorageAccountsService } from 'mbs-ui-shared@services/storage-accounts/storage-accounts.service';
import { AddStorageAccountWizardOpener, AddStorageAccountWizardOptions } from 'mbs-ui-shared@tokens/add-storage-account-wizard.token';
import { catchError, firstValueFrom, of } from 'rxjs';

const STORAGES_NAMESPACE = 'storages';

export function createAddStorageAccountWizardOpener(
  modalService: ModalService,
  storageAccountsService: StorageAccountsService,
  i18next: ITranslationService
): AddStorageAccountWizardOpener {
  return async (options?: AddStorageAccountWizardOptions): Promise<boolean> => {
    // The wizard's dictionary is bound to the storage routes, and this opener is reachable from any of them
    await i18next.loadNamespaces([STORAGES_NAMESPACE]).catch(() => null);

    const availableStorages = await firstValueFrom(
      storageAccountsService.getStoragesAvailableForStorageCreation().pipe(catchError(() => of([])))
    );

    const modal = modalService.openRef(AddStorageAccountWizardComponent, {
      size: MbsSize.lg,
      backdrop: 'static',
      keyboard: false
    });

    modal.componentInstance.mode = CreationMode.Create;
    modal.componentInstance.availableStorages = availableStorages;
    modal.componentInstance.companyIds = options?.companyIds;
    modal.componentInstance.lockedCompany = options?.lockedCompany;

    return modal.result.then((result) => result === 'success').catch(() => false);
  };
}
